import React from 'react';
import DashboardChartCard from './charts/DashboardChartCard';

function DashboardOverviewCharts({ charts }) {
    if (!charts.length) {
        return null;
    }

    return (
        <section className="dashboard-overview-charts" aria-label="Overview charts">
            <div className="dashboard-overview-charts__header">
                <h5 className="mb-0 fw-semibold text-dark">
                    <i className="bi bi-pie-chart-fill me-2 text-primary" />
                    Visual Overview
                </h5>
                <p className="mb-0 small text-muted">Key metrics at a glance from your latest scheduled refresh</p>
            </div>
            <div className="dashboard-overview-charts__grid">
                {charts.map((chart) => (
                    <DashboardChartCard key={chart.id} chart={chart} compact chartIndex={chart.chartIndex} />
                ))}
            </div>
        </section>
    );
}

export default DashboardOverviewCharts;
